module.exports = __webpack_public_path__ + "static/img/r4-text.4c44163.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traditional/home/mobile/role/r4-text.png
// module id = 9IyB
// module chunks = 0